import { render } from "./FaqCreate.vue?vue&type=template&id=5d76e478&scoped=true"
import script from "./FaqCreate.vue?vue&type=script&lang=js"
export * from "./FaqCreate.vue?vue&type=script&lang=js"

import "./FaqCreate.vue?vue&type=style&index=0&id=5d76e478&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d76e478"]])

export default __exports__